module.exports = __webpack_public_path__ + "static/img/xs1-3.564c4b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xs1-3.png
// module id = 795
// module chunks = 0